import { NextSeo } from 'next-seo';
import { useRouter } from 'next/router';

type SEO = {
    locale?: string;
    title?: string;
    keywords?: string;
    description?: string;
    titleTemplate?: string;
    additionalMetaTags?: Array<any>;
    hideTitleTemplate?: boolean;
};

const genKeywords = (words: string) => ({
    name: 'keywords',
    content: words,
});

export default function SEO({ title, keywords, description, titleTemplate = '', hideTitleTemplate = false }: SEO) {
    const { locale = 'us', pathname } = useRouter();
    //首页title的模板会跟其它页面不一样
    const isHome = pathname === '/';

    const seo: SEO = {
        titleTemplate: '',
    };

    if (hideTitleTemplate) {
        seo.titleTemplate = '';
    } else {
        seo.titleTemplate = titleTemplate ? `%s | ${titleTemplate}` : isHome ? `EcoFlow ${locale.toUpperCase()} | %s` : `%s | EcoFlow ${locale.toUpperCase()}`;
    }

    // if (['sa'].includes(locale)) {
    //     seo.titleTemplate = '%s | ايكو فلو EcoFlow Arabia';
    // }

    if (['kr'].includes(locale)) {
        seo.titleTemplate = '%s';
    }

    if (title) {
        seo.title = title;
    }

    if (keywords) {
        seo.additionalMetaTags = [genKeywords(keywords)];
    }

    if (description) {
        seo.description = description;
    }

    return <NextSeo {...seo} />;
}
